<!--
 * @Author: wangwei
 * @Date: 2020-12-29 15:56:16
 * @LastEditTime: 2023-09-21 19:37:49
 * @LastEditors: cuihaopeng cuihaopeng@slodon.cn
 * @Description: 订单支付页面
 * @FilePath: /java-pc/src/views/buy/pay.vue
-->
<template>
  <div id="pay">
    <div class="top_info">
      <div class="top_info_header">
        <div class="top_logo">
          <div :style="`background-image:url(${configInfo.pc_pay_logo})`" :onerror="defaultImg"></div>
        </div>
        <div class="top_info_progress flex_row_end_center">
          <div class="progress_item" v-if="ifcart == 'true'">
            <div class="progress flex_row_center_center">
              <span class="active">1</span>
              <div class="progress_line">
                <div :class="{ content: true, active: true }"></div>
              </div>
            </div>
            <p>{{ L['购物车'] }}</p>
          </div>

          <div class="progress_item">
            <div class="progress flex_row_center_center">
              <span class="active">{{ ifcart == 'true' ? 2 : 1 }}</span>
              <div class="progress_line">
                <div :class="{ content: true, active: true, current: false }"></div>
              </div>
            </div>
            <p style="margin-left: -11px">{{ L['确认订单'] }}</p>
          </div>

          <div class="progress_item">
            <div class="progress flex_row_center_center">
              <span class="active">{{ ifcart == 'true' ? 3 : 2 }}</span>
              <div class="progress_line">
                <div :class="{ content: true, active: payComplete }"></div>
              </div>
            </div>
            <p>{{ L['付款'] }}</p>
          </div>

          <div class="progress_item" style="margin-left: -30px">
            <div class="progress flex_row_end_center">
                <div class="progress_line" style="width:10px;">
                <div :class="{ content: true, active: payComplete }"></div>
              </div>
              <span :class="{ active: payComplete }">{{ ifcart == 'true' ? 4 : 3 }}</span>
            </div>
            <p>{{ L['支付成功'] }}</p>
          </div>
        </div>
      </div>

      <div class="order_info">
        <div class="top_info_text flex_row_between_between">
          <span>{{ L['订单提交成功，请您尽快付款！'] }} {{ L['支付订单号'] }}： {{ pay_info.data.paySn }}</span>
        </div>
        <div class="top_info_text price">
          {{ L['应付金额'] }}
          <span>{{ pay_info.data.needPay }}</span>
          {{ L['元'] }}
        </div>
        <!-- <div class="top_info_text flex_row_between_between">
                                                <span>
                                                    {{ L['请您在提交订单后'] }}
                                                    <span>24{{ L['小时内'] }}</span>{{ L['完成支付，否则订单会自动取消'] }}
                                                </span>
                                                <div class="show_detail pointer" @click="showDetail">{{ show_detail ? L['收起详情'] : L['展开详情'] }}</div>
        </div>-->
        <div class="receive_info">
          <p v-if="show_detail && pay_info.data.receiveAddress && pay_info.data.receiverName">
            {{ L['收货地址'] }}：{{ pay_info.data.receiveAddress }}
            {{ L['收货人'] }}：{{ pay_info.data.receiverName }}
            {{ pay_info.data.receiverMobile }}
          </p>
          <p v-if="show_detail">{{ L['商品名称'] }}：{{ buy_name_list }}</p>
        </div>
      </div>
    </div>
    <div class="bg">
      <!-- v-if="hasPayMethod" -->
      <div class="pay_method" v-if="!show_wx_pay">
        <!-- 重写支付方式 -->
        <div class="pay_content">
          <div class="pay_title">选择支付方式</div>
          <div class="pay_list flex">
            <!-- <div class="pay_item flex_row_between_center" :class="currentIndex == 0 ? 'active_item' : ''"
                            @click="checkPayType('wx', 'WX', 0)">
                            <img class="pay_img" :src="weixin" alt="">
                            <text>微信支付</text>
                            <img v-if="currentIndex == 0" class="icon" :src="selectpay" alt="">
                        </div>
                        <div class="pay_item flex_row_between_center" :class="currentIndex == 1 ? 'active_item' : ''"
                            @click="checkPayType('alipay', 'ALIPAY', 1)">
                            <img class="pay_img" :src="alpay" alt="">
                            <text>支付宝支付</text>
                            <img v-if="currentIndex == 1" class="icon" :src="selectpay" alt="">
            </div>-->
            <div
              class="pay_item flex_row_between_center"
              :class="currentIndex == index + 2 ? 'active_item' : ''"
              v-for="(item, index) in payList"
              :key="index"
              @click="checkPayType(item.payMethod, item.payType, index + 2)"
            >
              <img class="pay_img" :src="weixin" alt v-if="item.payMethod == 'wx'" />
              <img class="pay_img" :src="alpay" alt v-if="item.payMethod == 'alipay'" />
              <img class="pay_img" :src="paynext" alt v-if="item.payMethod == 'balance'" />
              <img class="pay_img" :src="orderPay" alt v-if="item.payMethod == 'credit'" />
              <img class="pay_img" :src="linePay" alt v-if="item.payMethod == 'offline'" />
              <text>{{ item.payMethodName }}</text>
              <img v-if="currentIndex == index + 2" class="icon" :src="selectpay" alt />
            </div>
          </div>

          <!-- 可用余额 余额充足 -->
          <div
            class="balancePayment"
            v-if="checkPayMethod == 'balance' && pay_info.data.balanceAvailable >= pay_info.data.needPay || checkPayMethod == 'credit' && pay_info.data.creditAvailable >= pay_info.data.needPay"
          >
            <div class="canPay">
              <text>{{checkPayMethod == 'credit'?'可用额度：':'可用余额：'}}</text>
              <text>
                {{ checkPayMethod == 'balance' ? pay_info.data.balanceAvailable.toFixed(2) :
                checkPayMethod
                == 'credit' ? pay_info.data.creditAvailable.toFixed(2) : 0 }}元
              </text>
            </div>
            <div class="payPsd">
              <text>支付密码：</text>
              <input type="password" placeholder="请输入支付密码" v-model="password" />
              <router-link 
                v-if="memberInfo.hasPayPassword"
                class="set_password pointer"
                style="margin-left:20px"
                :to="'/member/pwd/reset'"
              >
                忘记密码
              </router-link>
            </div>
            <p v-if="!memberInfo.hasPayPassword" class="pwd" style="margin-top:20px">
              <span style="color: #FFB33A;">
                <i class="el-icon-warning"></i>
                {{
                L['未设置支付密码，马上去设置'] }}
              </span>
              <router-link
                class="set_password pointer"
                style="margin-left:20px"
                :to="'/member/pwd/pay'"
              >
                {{
                L['设置密码'] }}
              </router-link>
            </p>
          </div>
          <div
            v-if="checkPayMethod == 'balance' && pay_info.data.balanceAvailable < pay_info.data.needPay || checkPayMethod == 'credit' && (pay_info.data.creditAvailable == null ? 0 : pay_info.data.creditAvailable) < pay_info.data.needPay"
            class="noBalancePayment"
          >
            可用余额：{{ checkPayMethod == 'balance' ?
            pay_info.data.balanceAvailable.toFixed(2) : checkPayMethod == 'credit' ?
            (pay_info.data.creditAvailable == null ? 0 : pay_info.data.creditAvailable).toFixed(2) :
            0 }}元，请选择其他支付方式或去<p class="weight pointer" @click="goRecharge" style="color:#168ED8;display: inline-block;">充值</p>
          </div>

          <!-- 线下支付 -->
          <div class="offlinePayment" v-if="checkPayMethod == 'offline'">
            <div class="offPayInfo">
              <div class="title">收款信息</div>
              <div class="item_info">
                <text>户名：</text>
                <text>
                  {{ bankInfo.admin_bank_account_name ? bankInfo.admin_bank_account_name : '未设置'
                  }}
                </text>
              </div>
              <div class="item_info">
                <text>开户行：</text>
                <text>{{ bankInfo.admin_bank_name ? bankInfo.admin_bank_name : '未设置' }}</text>
              </div>
              <div class="item_info">
                <text>帐号：</text>
                <text>{{ bankInfo.bank_account_number ? bankInfo.bank_account_number : '未设置' }}</text>
              </div>
            </div>
            <div class="offPayInfo">
              <div class="title">请上传付款凭证</div>
              <div style="display:flex">
                <div class="upImg flex_row_center_center">
                  <el-upload
                    class="avatar-uploader"
                    :action="apiUrl + 'v3/oss/common/upload'"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :data="upload_data"
                    name="file"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl.data[0]" :src="imageUrl.data[0]" class="avatar" />
                    <el-icon v-else class="avatar-uploader-icon">
                      <Plus />
                    </el-icon>
                  </el-upload>
                </div>
                <div class="upImg flex_row_center_center">
                  <el-upload
                    class="avatar-uploader"
                    :action="apiUrl + 'v3/oss/common/upload'"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess1"
                    :data="upload_data"
                    name="file"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl.data[1]" :src="imageUrl.data[1]" class="avatar" />
                    <el-icon v-else class="avatar-uploader-icon">
                      <Plus />
                    </el-icon>
                  </el-upload>
                </div>
                <div class="upImg flex_row_center_center">
                  <el-upload
                    class="avatar-uploader"
                    :action="apiUrl + 'v3/oss/common/upload'"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess2"
                    :data="upload_data"
                    name="file"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl.data[2]" :src="imageUrl.data[2]" class="avatar" />
                    <el-icon v-else class="avatar-uploader-icon">
                      <Plus />
                    </el-icon>
                  </el-upload>
                </div>
              </div>

              <div class="notPay">如果暂时无法支付，请在完成支付后上传付款凭证。</div>
            </div>
          </div>
        </div>

        <!-- 按钮 -->
        <div
          class="pay_btn flex_row_center_center"
          v-if="!(checkPayMethod == 'balance' && pay_info.data.balanceAvailable < pay_info.data.needPay || checkPayMethod == 'credit' && ((pay_info.data.creditAvailable == null ? 0 : pay_info.data.creditAvailable) < pay_info.data.needPay))"
        >
          <el-button class="toPay" @click="pay">立即支付</el-button>
        </div>
        <!-- <div v-if="!show_wx_pay">
                    <div class="balance" v-if="balance_list.data.length > 0">
                        <img class="logo" :src="balance" alt />
                        <div class="balance_info flex_row_start_center">
                            <img v-if="current_pay_method.data.payMethod == balance_list.data[0].payMethod"
                                class="pay_checked" :src="paychecked" alt />
                            <i v-else :class="{
                                iconfont: true,
                                'icon-yuanquan1': pay_info.data.balanceAvailable >= pay_info.data.needPay,
                                'icon-duihao1': current_pay_method.data.payMethod == balance_list.data[0].payMethod,
                                'icon-jinzhi1': pay_info.data.balanceAvailable < pay_info.data.needPay
                            }"
                                @click="pay_info.data.balanceAvailable > pay_info.data.needPay ? changePayMethod(balance_list.data[0]) : ''"></i>

                            <span class="weight big_size">{{ L['使用余额支付'] }}</span>
                            <span class="avai">
                                （{{ L['可用余额'] }}：
                                <span class="weight">{{ pay_info.data.balanceAvailable }}</span>{{ L['元，目前需要在线支付'] }}：
                                <span class="weight">{{ pay_info.data.needPay }}</span>{{ L['元）余额不足？'] }}
                                <span class="weight pointer" @click="goRecharge" style="color:#168ED8">{{
                                    L['马上充值'] }}</span>
                            </span>
                        </div>
                        <div class="password" v-if="current_pay_method.data.payMethod == balance_list.data[0].payMethod">
                            <el-input class="password_input" :placeholder="L['支付密码']" v-model="password" show-password>
                            </el-input>
                            <p v-if="!memberInfo.hasPayPassword">
                                <span style="color: #FFB33A;"><i class="el-icon-warning"></i>{{
                                    L['未设置支付密码，马上去设置'] }}</span>
                                <router-link class="set_password pointer" :to="'/member/pwd/pay'">{{
                                    L['设置密码'] }}</router-link>
                            </p>
                            <p v-else>
                                <span class="forget_password pointer" @click="forgetPassword">{{ L['忘记密码'] }}?</span>
                            </p>
                        </div>
                    </div>
                    <div class="balance other_pay_method" v-if="other_pay_list.data.length > 0">
                        <img class="logo" :src="otherPay" alt />
                        <div class="balance_info flex">
                            <div :class="{ other_pay_item: true, flex_row_center_center: true, wechat: index != 0 }"
                                v-for="(item, index) in other_pay_list.data" :key="index" @click="changePayMethod(item)">
                                <i v-if="current_pay_method.data.payMethod != item.payMethod"
                                    class="iconfont icon-yuanquan1"></i>
                                <img class="pay_checked" v-else :src="paychecked" alt />


                                <img class="pay_check_list" v-if="item.payMethod == 'alipay'" :src="ali" alt />
                                                <img class="pay_check_list" v-else-if="item.payMethod == 'wx'" :src="wechat" alt />
                                                <img class="pay_check_list" v-else-if="item.payMethod == 'paypal'" :src="paypal" alt />
                            </div>
                        </div>
                    </div>
                                    <div class="pay" @click="pay" style="cursor: pointer;">{{ L['立即支付'] }}</div>
                                </div>
        -->

        <!-- <div class="no_payMethod">
                                    <img src="@/assets/member/member_empty.png" alt="">
                                    <p>{{ L['暂无可用的支付方式，平台正在紧急处理中～'] }}</p>
        </div>-->
      </div>
      <div class="wx_pay_con" v-if="show_wx_pay">
        <p class="title" @click="hideWxPay">
          <i class="iconfont icon-ziyuan2"></i>
          <span>{{ L['选择其它支付方式'] }}</span>
        </p>
        <div class="qr flex_row_around_center">
          <div class="left flex_column_start_center">
            <img :src="wxPayQrImg" />
            <p>
              {{ L['使用'] }}
              <span>{{ L['微信支付'] }}</span>APP
            </p>
            <p>{{ L['扫码完成支付'] }}</p>
            <div class="refresh" @click="refreshWxQrcode">{{ L['刷新'] }}</div>
          </div>
          <img class="wx_png" :src="wx_pay_tip" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, getCurrentInstance, ref, onMounted, onUnmounted } from "vue";
import { ElMessage, ElInput } from "element-plus";
import { Plus } from "@element-plus/icons";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { apiUrl } from "../../utils/config";
export default {
  name: "Pay",
  components: {
    ElInput,
    Plus
  },
  setup() {
    const ifcart = ref("");
    const balance = require("../../assets/buy/balance.png");
    const otherPay = require("../../assets/buy/otherPay.png");
    const ali = require("../../assets/buy/pay_ali.png");
    const wechat = require("../../assets/buy/pay_wechat.png");
    const paypal = require("../../assets/buy/pay_paypal.png");
    const wx_pay_tip = require("../../assets/buy/wx_pay_tip.png");
    const paychecked = require("../../assets/buy/selected_pay.png");
    // 新增图片
    const selectpay = require("../../assets/buy/selectpay.png");
    const weixin = require("../../assets/buy/wxPay.png");
    const alpay = require("../../assets/buy/alpay.png");
    const paynext = require("../../assets/buy/paynext.png");
    const orderPay = require("../../assets/buy/orderPay.png");
    const linePay = require("../../assets/buy/linePay.png");
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const pay_method = reactive({ data: [] });
    const pay_info = reactive({ data: {} });
    const paySn = ref("");
    const current_pay_method = reactive({ data: {} });
    const balance_list = reactive({ data: [] });
    const other_pay_list = reactive({ data: [] });
    const buy_name_list = ref("");
    const password = ref("");
    const show_wx_pay = ref(false);
    const wxPayQrImg = ref(""); //微信支付二维码
    const timer = ref(0); //定时器
    const show_detail = ref(true);
    const hasPayMethod = ref(true);
    const configInfo = ref(store.state.configInfo);
    const memberInfo = ref(store.state.memberInfo);
    const defaultImg = ref(
      'this.src="' + require("../../assets/common_top_logo.png") + '"'
    );
    const isPreventClick = ref(false); //防止多次提交支付

    // 新增
    const payList = reactive([
      // { img: weixin, title: '微信支付', payMethod: 'wx' },
      // { img: alpay, title: '支付宝', payMethod: 'alipay' },
      // { img: paynext, title: '余额支付', payMethod: 'balance' },
      // { img: orderPay, title: '信用支付', payMethod: 'credit' },
      // { img: linePay, title: '线下支付', payMethod: 'offline' },
    ]);
    const checkPayMethod = ref("wx");
    const toCheckPayType = ref("");
    const currentIndex = ref(0); // 选中支付方式的索引
    const bankInfo = reactive({
      admin_bank_account_name: "",
      bank_account_number: "",
      admin_bank_name: ""
    });
    const imageUrl = reactive({data:[]});
    const imgPath = reactive({data:[]});
    const upload_data = reactive({
      source: "evaluate"
    });

    const checkPayType = (payMethod, payType, index) => {
      currentIndex.value = index;
      checkPayMethod.value = payMethod;
      toCheckPayType.value = payType;
    };
    //获取支付方式
    const getPayMethod = () => {
      proxy
        .$get("v3/business/front/orderPay/payMethod", {
          source: "pc",
          type: 1,
          paySn: route.query.paySn,
        })
        .then(res => {
          if (res.state == 200) {
            hasPayMethod.value = res.data.length > 0 ? true : false;
            res.data.map(item => {
              if (item.payMethod == "balance") {
                payList.push(item);
                balance_list.data.push(item);
              } else {
                other_pay_list.data.push(item);
                payList.push(item);
              }
            });
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    //获取订单支付数据
    const getPayInfo = () => {
      proxy
        .$get("v3/business/front/orderPay/payInfo", {
          paySn: route.query.paySn,
          payFrom: route.query.payFrom
        })
        .then(res => {
          if (res.state == 200) {
            pay_info.data = res.data;
            buy_name_list.value = res.data.goodsNameList.join(" + ");
            // 银行信息（赋值给 bankInfo，对应线下支付模板使用）
            bankInfo.admin_bank_account_name = res.data.bankAccountInfo.accountName || ""; // 户名
            bankInfo.bank_account_number = res.data.bankAccountInfo.accountNumber || "";       // 账号
            bankInfo.admin_bank_name = res.data.bankAccountInfo.bankName || "";               // 开户行    
        // 支付页Logo（赋值给 configInfo，对应顶部Logo使用）
        configInfo.value.pc_pay_logo = res.data.pc_pay_logo || "";

          } else if (res.state == 267) {
            ElMessage.success(res.msg + L[",2s后自动跳转订单列表"]);
            //清除定时器
            if (timer.value) {
              clearInterval(timer.value);
              timer.value = 0;
            }
            setTimeout(() => {
              router.replace({
                path: "/member/order/list"
              });
            }, 2000);
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch(() => {
          //异常处理
        });
    };
    const changePayMethod = pay_method => {
      current_pay_method.data = pay_method;
    };
    //去支付
    const payComplete = ref(false);
    const pay = () => {
      let param = {};
      param.payType = toCheckPayType.value;
      param.payMethod = checkPayMethod.value;
      param.paySn = pay_info.data.paySn;

      //余额支付
      // console.log(checkPayMethod.value, !(pay_info.data.balanceAvailable < pay_info.data.needPay))
      if (
        (checkPayMethod.value == "balance" &&
          pay_info.data.balanceAvailable < pay_info.data.needPay) ||
        (checkPayMethod.value == "credit" &&
          (pay_info.data.creditAvailable == null
            ? 0
            : pay_info.data.creditAvailable) < pay_info.data.needPay)
      ) {
        ElMessage.warning("可用余额不足，请选择其他支付方式");
        return;
      }
      if (param.payMethod == "balance" || param.payMethod == "credit") {
        if (password.value == "") {
          ElMessage.warning(L["请输入支付密码"]);
          return;
        }
        param.payPwd = password.value; //支付密码,使用余额时必传
        // 判断是否设置支付密码
        isSetPassword();
      }

      if (param.payMethod == "offline") {
        if (imgPath.data) {
          param.paymentVoucher = imgPath.data.join(',');
        }
      }
      // console.log(isPreventClick.value,11)

      if (isPreventClick.value) return;
      isPreventClick.value = true;

      //请求支付接口
      proxy
        .$post("v3/business/front/orderPay/doPay", param)
        .then(res => {
          if (res.state == 200) {
            var redirectpath = "/member/order/list";
            var orderState = "";
            if (
              param.payMethod == "balance" ||
              param.payMethod == "credit" ||
              param.payMethod == "offline"
            ) {
              if(res.data?.unPaidOrderCount ?? 0 > 0) {
                orderState = "10";
                ElMessage.success(L["支付成功,还有"] +  res.data.unPaidOrderCount + L["个订单未支付，请及时支付"]);
              }else{
                ElMessage.success(L["支付成功,2s后自动跳转订单列表"]);
              }
              payComplete.value = true;
              //清除定时器
              setTimeout(() => {
                isPreventClick.value = false;
                router.replace({
                  path: redirectpath,
                  query: {
                    orderState: orderState
                  }
                });
              }, 2000);
            } else if (param.payMethod == "alipay") {
              isPreventClick.value = false;
              document.write(res.data.payData); //自动提交表单数据
            } else if (param.payMethod == "wx") {
              show_wx_pay.value = true;
              wxPayQrImg.value = "data:image/png;base64," + res.data.payData; //微信支付二维码
              isPreventClick.value = false;
              // 定时查询是否支付成功
              timer.value = setInterval(() => {
                queryPayState();
              }, 3000);
              //两小时自动跳转订单列表
              setTimeout(() => {
                router.replace({
                  path: redirectpath
                });
              }, 432000000);
            } else if (param.payMethod == "paypal") {
              if (res.state == 200 && res.data.payData) {
                isPreventClick.value = false;
                window.location.href = res.data.payData;
              } else {
                ElMessage.error(res.msg);
                isPreventClick.value = false;
              }
            }
          } else if (res.state == 267) {
            proxy
              .$confirm(res.msg, "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning"
              })
              .then(() => {
                router.push("/member/pwd/pay");
              });
          } else {
            ElMessage.error(res.msg);
            isPreventClick.value = false;
          }
        })
        .catch(() => {
          //异常处理
          isPreventClick.value = false;
        });
    };
    // 定时查询是否支付成功
    const queryPayState = () => {
      getPayInfo();
    };
    //隐藏微信支付内容
    const hideWxPay = () => {
      show_wx_pay.value = false;
    };
    //刷新微信支付二维码
    const refreshWxQrcode = () => {
      pay();
    };
    //收起展开详情
    const showDetail = () => {
      show_detail.value = !show_detail.value;
    };
    onMounted(() => {
      paySn.value = route.query.paySn;
      ifcart.value = route.query.ifcart;
      getPayMethod();
      getPayInfo();

      // // 获取线下支付信息
      // getPayLine();
    });
    const goRecharge = () => {
      router.push("/member/recharge");
    };
    const forgetPassword = () => {
      router.push("/member/pwd/reset");
    };

    // // 获取线下支付数据
    // const getPayLine = () => {
    //   let param = {
    //     names:
    //       "offline_pc_pay_name,offline_pc_pay_number,offline_pc_pay_bank,pc_pay_logo"
    //   };
    //   proxy.$get("v3/system/front/setting/getSettings", param).then(res => {
    //     bankInfo.admin_bank_account_name = res.data[0];
    //     bankInfo.bank_account_number = res.data[1];
    //     bankInfo.admin_bank_name = res.data[2];
    //     configInfo.value.pc_pay_logo = res.data[3];
    //   });
    // };

    // 判断是否设置支付密码
    const isSetPassword = () => {
      proxy.$get("v3/business/front/orderPay/payPwdCheck").then(res => {
        if (res.data == false) {
          ElMessage.warning("您还没有设置支付密码");
        }
      });
    };

    // 上传图片
    const handleAvatarSuccess = (response, uploadFile) => {
      imageUrl.data[0] = response.data.url;
      imgPath.data[0] = response.data.path;
    };
    const handleAvatarSuccess1 = (response, uploadFile) => {
      imageUrl.data[1] = response.data.url;
      imgPath.data[1] = response.data.path;
    };
    const handleAvatarSuccess2 = (response, uploadFile) => {
      imageUrl.data[2] = response.data.url;
      imgPath.data[2] = response.data.path;
    };

    const beforeAvatarUpload = rawFile => {
      if (rawFile.type !== "image/jpeg" && rawFile.type !== "image/png") {
        ElMessage.error("请上传jpeg/png格式的图片!");
        return false;
      } else if (rawFile.size / 1024 / 1024 > 5) {
        ElMessage.error("最大只能上传 5MB!");
        return false;
      }
      return true;
    };
    onUnmounted(() => {
      if (timer.value) {
        clearInterval(timer.value);
        timer.value = 0;
      }
    });
    return {
      pay_method,
      balance,
      otherPay,
      ali,
      wechat,
      paypal,
      pay_info,
      current_pay_method,
      balance_list,
      other_pay_list,
      changePayMethod,
      buy_name_list,
      password,
      pay,
      wx_pay_tip,
      show_wx_pay,
      hideWxPay,
      refreshWxQrcode,
      wxPayQrImg,
      goRecharge,
      forgetPassword,
      showDetail,
      show_detail,
      hasPayMethod,
      configInfo,
      defaultImg,
      memberInfo,
      payComplete,
      isPreventClick,
      paychecked,
      L,
      // 新增
      payList,
      currentIndex,
      selectpay,
      weixin,
      alpay,
      paynext,
      checkPayType,
      orderPay,
      linePay,
      checkPayMethod,
      isSetPassword,
      // getPayLine,
      bankInfo,
      handleAvatarSuccess,
      handleAvatarSuccess1,
      handleAvatarSuccess2,
      beforeAvatarUpload,
      apiUrl,
      upload_data,
      imageUrl,
      imgPath
    };
  }
};
</script>

<style lang="scss">
@import "../../style/pay.scss";
@import "../../style/base.scss";

.no_payMethod {
  margin: 0 auto;
  width: 1200px;
  height: 560px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    width: 163px;
    height: 114px;
  }

  p {
    margin-top: 39px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
}
</style>